"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.textStyles = exports.paragraphSizeToTextSize = void 0;
const lit_1 = require("lit");
const utils_1 = require("@/utils");
exports.paragraphSizeToTextSize = {
    small: '12',
    medium: '14',
    large: '18',
};
const textMaxLinesTokens = {
    2: { '-webkit-line-clamp': '2' },
    3: { '-webkit-line-clamp': '3' },
};
const textMaxLinesStyles = (0, lit_1.css) `
  /* max-lines는 reflect라 값이 없을 때도 attribute가 남는다. 값이 있을 때만 자른다. */
  :host([max-lines]:not([max-lines=''])) > * {
    overflow: hidden;
    text-overflow: ellipsis;
  }

  :host([max-lines='1']) > * {
    display: block;
    white-space: nowrap;
  }

  :host([max-lines='2']) > *,
  :host([max-lines='3']) > * {
    display: -webkit-box;
    -webkit-box-orient: vertical;
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('max-lines', textMaxLinesTokens, '> *'))}
`;
const textColorTokens = {
    light: { color: 'var(--foreground-subtle-color)' },
    danger: { color: 'var(--danger-color)' },
};
const textSizeTokens = {
    '12': { 'font-size': 'var(--font-size-12)', 'line-height': 'var(--font-line-height-16)' },
    '14': { 'font-size': 'var(--font-size-14)', 'line-height': 'var(--font-line-height-24)' },
    '18': { 'font-size': 'var(--font-size-18)', 'line-height': 'var(--font-line-height-28)' },
    '24': { 'font-size': 'var(--font-size-24)', 'line-height': 'var(--font-line-height-32)' },
    '32': { 'font-size': 'var(--font-size-32)', 'line-height': 'var(--font-line-height-40)' },
};
exports.textStyles = (0, lit_1.css) `
  :host {
    display: block;
    color: inherit;
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('color', textColorTokens))}

  :host([centered]) {
    display: block;
    text-align: center;
  }

  ${(0, lit_1.unsafeCSS)((0, utils_1.buildAttributeRules)('size', textSizeTokens))}

  :host([weight='bold']) {
    font-weight: var(--font-weight-bold);
  }

  ${textMaxLinesStyles}
`;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoidGV4dC5zdHlsZXMuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJ0ZXh0LnN0eWxlcy50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiOzs7QUFBQSw2QkFBb0M7QUFJcEMsbUNBQW1FO0FBVXRELFFBQUEsdUJBQXVCLEdBQW9DO0lBQ3RFLEtBQUssRUFBRSxJQUFJO0lBQ1gsTUFBTSxFQUFFLElBQUk7SUFDWixLQUFLLEVBQUUsSUFBSTtDQUNaLENBQUE7QUFFRCxNQUFNLGtCQUFrQixHQUFHO0lBQ3pCLENBQUMsRUFBRSxFQUFFLG9CQUFvQixFQUFFLEdBQUcsRUFBRTtJQUNoQyxDQUFDLEVBQUUsRUFBRSxvQkFBb0IsRUFBRSxHQUFHLEVBQUU7Q0FDakMsQ0FBQTtBQUVELE1BQU0sa0JBQWtCLEdBQUcsSUFBQSxTQUFHLEVBQUE7Ozs7Ozs7Ozs7Ozs7Ozs7OztJQWtCMUIsSUFBQSxlQUFTLEVBQUMsSUFBQSwyQkFBbUIsRUFBQyxXQUFXLEVBQUUsa0JBQWtCLEVBQUUsS0FBSyxDQUFDLENBQUM7Q0FDekUsQ0FBQTtBQUVELE1BQU0sZUFBZSxHQUFtRDtJQUN0RSxLQUFLLEVBQUUsRUFBRSxLQUFLLEVBQUUsZ0NBQWdDLEVBQUU7SUFDbEQsTUFBTSxFQUFFLEVBQUUsS0FBSyxFQUFFLHFCQUFxQixFQUFFO0NBQ3pDLENBQUE7QUFFRCxNQUFNLGNBQWMsR0FBOEI7SUFDaEQsSUFBSSxFQUFFLEVBQUUsV0FBVyxFQUFFLHFCQUFxQixFQUFFLGFBQWEsRUFBRSw0QkFBNEIsRUFBRTtJQUN6RixJQUFJLEVBQUUsRUFBRSxXQUFXLEVBQUUscUJBQXFCLEVBQUUsYUFBYSxFQUFFLDRCQUE0QixFQUFFO0lBQ3pGLElBQUksRUFBRSxFQUFFLFdBQVcsRUFBRSxxQkFBcUIsRUFBRSxhQUFhLEVBQUUsNEJBQTRCLEVBQUU7SUFDekYsSUFBSSxFQUFFLEVBQUUsV0FBVyxFQUFFLHFCQUFxQixFQUFFLGFBQWEsRUFBRSw0QkFBNEIsRUFBRTtJQUN6RixJQUFJLEVBQUUsRUFBRSxXQUFXLEVBQUUscUJBQXFCLEVBQUUsYUFBYSxFQUFFLDRCQUE0QixFQUFFO0NBQzFGLENBQUE7QUFFWSxRQUFBLFVBQVUsR0FBRyxJQUFBLFNBQUcsRUFBQTs7Ozs7O0lBTXpCLElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsT0FBTyxFQUFFLGVBQWUsQ0FBQyxDQUFDOzs7Ozs7O0lBT3hELElBQUEsZUFBUyxFQUFDLElBQUEsMkJBQW1CLEVBQUMsTUFBTSxFQUFFLGNBQWMsQ0FBQyxDQUFDOzs7Ozs7SUFNdEQsa0JBQWtCO0NBQ3JCLENBQUEifQ==